import { useEffect, useMemo, useRef } from 'react';

// global counter to ensure unique ids during static build
let inc = 0;

const useRandomIds = (namespace: string, count: number, deps: unknown[]) => {
  const ref = useRef<() => string>();

  // use effect won't run during static build
  useEffect(() => {
    try {
      crypto.randomUUID();
      ref.current = () => crypto.randomUUID();
    } catch {
      ref.current = () => Math.random().toString(36).substring(2);
    }
  }, []);

  const ids = useMemo(
    () =>
      // eslint-disable-next-line no-plusplus
      Array.from({ length: count }, () => (ref.current ? ref.current() : `${namespace}-${inc++}`)),
    deps,
  );

  return ids;
};

export default useRandomIds;
